import { marked } from 'marked'
import DOMPurify from 'dompurify'

const getters = { 
    projectLoaded: state => {
        if(state.projectData == "") {
            return false
        }
        return true
    }, 
    filterActiveProject: (state, getters) => {
        ////console.log("filterActiveProject 1", state.projectData)
        //console.log("filterActiveProject 2", state.selectedProject)
        if(!state.selectedProject) {
            return null
        }
        return getters.fetchProject(state.selectedProject)
        // return state.projectData.filter(item => item.project_id === state.selectedProject)
    },
    fetchProject: (state) => (id) => {
        //console.log("fetchProject 1", id)
        return state.projectData.find(item => item.project_id === id)
    },
    /* isProjectLocked: (state) => (id) => {
        const project = state.projectData.find(item => item.project_id === id)
        if (!project || !project.locked_until) return false
        return new Date(project.locked_until) > new Date()
    }, */
    formatDate: () => (dateString) => {
        if (!dateString) return 'Non définie'
        const date = new Date(dateString)
        return date.toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    },
    formatNumberWithSeparator: () => (value) => { 
        if (value === null || value === undefined || value === '') return '';
        return Number(value).toLocaleString('de-CH', {
            /* minimumFractionDigits: 2, */
            maximumFractionDigits: 2
        });
    },
    fetchChildrenCriteria: (state) => (ids) => {
        return [...state.criteriaTree.filter(item => ids.includes(item.id)).sort((a, b) => a.order_number - b.order_number)]
    },
    filterProductionReferential: (state, getters, rootState) => {
        // //console.log("filterProductionReferential 1", rootState.referential.referentialData)
        return rootState.referential.referentialData.filter(
            item => item.status === "RELEASE"
        )
    },
    renderedMarkdown: () => (markdown) => {
        if (typeof markdown !== 'string') {
            return '';
        }
        const renderer = new marked.Renderer();
        const linkRenderer = renderer.link;
        renderer.link = (href, title, text) => {
            const html = linkRenderer.call(renderer, href, title, text);
            return html.replace(/^<a /,'<a target=_blank rel="noopener noreferrer"');
        };
            
        const rawMarkup = marked(markdown, {renderer});
        return DOMPurify.sanitize(rawMarkup, {
            ADD_ATTR: ['target']
        });
    },
    fetchRootCriteria: (state) => (project) => {
        if (!project) return null;
        /* //console.log("fetchRootCriteria entered with project", project)
        //console.log("criteriaTree Initialized?", state.criteriaTree && state.criteriaTree.length > 0)
        //console.log("fetchRootCriteria found criteria", state.criteriaTree.find(item => item.parent === null)) */
        return state.criteriaTree.find(item => item.parent === null);
    },
    generalDataConfigOrdered: (state) => {
        return state.generalData
        .sort((a, b) => {
            if(a.chapter < b.chapter) return -1
            if(a.chapter > b.chapter) return 1
            if(a.view_order < b.view_order) return -1
            if(a.view_order > b.view_order) return 1
            return 0;
        });
    }, 
    generalDataConfigByChapter: (state) => (chapter) => {
        const singles = state.generalData.filter(item => item.chapter === chapter && item.count === 0)
        const multiples = state.generalData.filter(item => item.chapter === chapter && item.count >= 1)

        ////console.log("generalDataConfigByChapter", chapter, singles.length, multiples.length)

        let columns = []
        let rows = []
        let titles = []
        if(multiples.length > 0) {
            titles = multiples[0].titles
            columns = multiples.map(item => ({
                tag: item.tag,
                symbol: item.symbol,
                unit: item.unit,
                description: item.description,
                comment: item.comment,
                type: item.type,
                dropdown: item.dropdown,
                item: item,
            }))
            rows = titles.map( title => {
                const row = { title: title }
                multiples.forEach(( item ) => {
                    const idx = item.titles.indexOf(title)
                    row[item.tag] = idx !== -1 ? item.values[idx] : null
                })
                return row
            })
            // item.titles.forEach((title, i) => {
            //     if (!chapterGroups[chapter].rows[title]) {
            //         chapterGroups[chapter].rows[title] = { title, values: {} }
            //     }
            //     chapterGroups[chapter].rows[title].values[item.tag] = item.values[i]
            //     chapterGroups[chapter].rows[title].index = i
            //     // //console.log("Item for i", i, item)
            //     // chapterGroups[chapter].rows[title].valuesBySymbol = item.valuesBySymbol[i]
            // })
        }
        // //console.log("titles, columns, rows", titles, columns, rows)

        // //console.log("Multiples", multiples)
        return {
            singles: singles,
            multiples: multiples,
            columns: columns,
            titles: titles,
            rows: rows,
        }

        // return state.generalData.filter(item => item.chapter === chapter)
    },
    generalDataGetChapters: (state) => {
        const chapters = new Set();
        //console.log("chapters :", chapters)
        const order = {
        "Surfaces et volumes (référence SIA 416 et SIA 421)": 0,
        "Géométrie du bâtiment": 1,
        "Agents énergétiques":2,
        "Chauffage":3,
        "ECS":4,
        "Froid":5,
        "Informations économiques":7,
        "Stationnement propre au projet":6
        };
        state.generalData.forEach(item => {
            if (item.chapter) {
                //console.log("item.chapter :", item.chapter, "\nchapters[item] :",chapters[item], "\nitem :",item)
                chapters.add(item.chapter);
            }
            //console.log("chapters final :", chapters)
        });
        return Array.from(chapters).sort((a, b) => {
            const indexA = order[a] !== undefined ? order[a] : 999;
            const indexB = order[b] !== undefined ? order[b] : 999;
        
            return indexA - indexB;
        });
    },
    // randomShareCodeGenerator: () => {
    //     //console.log("randomShareCodeGenerator entered")
    //     const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+@#%&()?!$-_='
    //     let shareCode = ''
    //     for (let i = 0; i < 8; i++) {
    //         shareCode += characters.charAt(Math.floor(Math.random() * characters.length))
    //     }
    //     //console.log("randomShareCodeGenerator generated", shareCode)
    //     return shareCode
    // },

    usersWithAccess: (state) =>  {
        const rolesMap = {}

        // Build a map of user_id -> { PC: boolean, PE: boolean }
        state.userListRightsProject.forEach(entry => {
            if (!rolesMap[entry.user_id]) {
                rolesMap[entry.user_id] = { /* PE: false, */ PC: false }
            }
            if (typeof entry.roles === "string") {
                const rolesArray = entry.roles.split(",").map(role => role.trim())
                //console.log("rolesArray", rolesArray)
                if (rolesArray.includes("PC")) {
                    rolesMap[entry.user_id].PC = true
                }
                if (rolesArray.includes("PE")) {
                    rolesMap[entry.user_id].PE = false
                }
            }
        });
        return state.userList
        .filter(user => rolesMap[user.user_id] && rolesMap[user.user_id].PC)
        .map(user => ({
            user_id: user.user_id,
            name: user.name,
            surname: user.surname,
            username: user.username,
            email: user.email,
            admin: user.adminRole,
            PC:(rolesMap[user.user_id].PC),
            //PE:(rolesMap[user.user_id].PE)
        }))
        .sort((a, b) => {
            /* if(a.admin < b.admin) return 1 */
            if(a.name < b.name) return -1
            if(a.name > b.name) return 1
            if(a.surname < b.surname) return -1
            if(a.surname > b.surname) return 1
            return 0
        });
    },
    usersWithoutAccess: (state) => {
        const usersWithRights = new Set(state.userListRightsProject.map(entry => entry.user_id));
        
        return state.userList
        .filter(user => !usersWithRights.has(user.user_id))
        .map(user => ({
            user_id: user.user_id,
            name: user.name,
            surname: user.surname,
            username: user.username,
            email: user.email,
            admin: user.adminRole,
            PC: false,
            //PE: false
        }))
        .sort((a,b) => {
            if(a.name < b.name) return -1;
            if(a.name > b.name) return 1;
            if(a.surname < b.surname) return -1;
            if(a.surname > b.surname) return 1;
            return 0;
        })
    },
    //, "readOnlyProject", "isEvaluationView"]),
    readOnlyProject: (state, getters, rootState) => {
        const project = state.projectData.find(item => item.project_id === state.selectedProject)
        const projectCreator = state.userListRightsProject.find(item => item.user_id === rootState.auth.userInfo.id && item.roles.includes("PC"))
        var projectOwner = false
        if(project && rootState.auth.userInfo) {
            projectOwner = rootState.auth.userInfo.id === project.created_by
        }
        if(!project || !(projectCreator || projectOwner)) {
            return true
        }
        if(project.status !== "EDITING") {
            return true
        }
        return false

        /* return true */
    },
    isEvaluationView: (state, getters) => {

        //Need the userListRightsProject to be loaded correctly if you want proper answers
        if(!state.userListRightsProject)return false;
        //console.log("DONNE MOI LES DROITS DISPO STPPPPP isEvaluationView : ",state.userListRightsProject);

        // const projectValidator = state.userListRightsProject.find(item => item.user_id === rootState.auth.user.id && item.roles.includes("PE") && !item.roles.includes("PC"))
        // const project = state.projectData.find(item => item.project_id === state.selectedProject)
        const project = getters.filterActiveProject
        //console.log("isEvaluationView - project", project)
        if(!project) {
            return false
        }
        if(project.status !== "VALIDATION") {
            //console.log("isEvaluationView - just know that your project has the wrong statut", project.status)
            return false
        }
        if(!project.PE) {
            return false
        }
        //console.log("isEvaluationView -- should be good right ?", project)
        return true
    },
    isEditableEvaluationComment: (state, getters)=> {
        //console.log("DONNE MOI LES DROITS DISPO STPPPPP isEditableEvaluationComment : ",state.userListRightsProject);
        const project = getters.filterActiveProject
        //console.log("isEditableEvaluationComment - project", project)
        if(!project) {
            return false
        }
        /* if(project.status !== "VALIDATION") {
            //console.log("isEvaluationView - just know that your project has the wrong statut", project.status)
            return false
        } */
        if(!project.PE) {
            return false
        }
        //console.log("isEditableEvaluationComment -- should be good right ?", project)
        return true
    },
    getEvaluationOptions() {
        return [
        { id: "NONE", value: 'Aucune' },
        { id: "OK", value: 'Validé' },
        { id: "NOK", value: 'Validé avec réserve' },
        { id: "RETURN", value: 'À corriger / compléter / coordoner' }
        ];
    },
    getEvaluationForCriteria: (state) => (criteriaId) => {
        const criteria = state.criteriaEvaluation.find(item => item.criteria_id === criteriaId)
        if (!criteria) {
            return { id: "NONE", value: 'Aucune' };
        }
        return criteria
    },

    formattedDisplayLine: () => (text) => {
        if(typeof text != String || typeof text != Number )return;
        return text.replace(/\n/g, '<br>')
    },
}

export default getters;